<template>
  <div>
    <v-icon large @click="selectIcon(icon)" class="ma-3 icon" :class="{ 'active': selectedIcon == '$' + icon }" v-for="(icon, index) in icons" :key="`icon-${index}`" >${{icon}}</v-icon>
  </div>
</template>

<script>

export default {
  name: 'IconPicker',
  props: ['active'],
  data () {
    return {
      selectedIcon: null,
      icons: [
        'announcement',
        'badge',
        'cart',
        'campaign',
        'eat',
        'feedback',
        'flag',
        'flask',
        'gift',
        'heart',
        'key',
        'leaf',
        'mix',
        'more',
        'nutrition',
        'recycle',
        'share',
        'star',
        'sustainability',
        'tools'
      ]
    }
  },
  methods: {

    selectIcon (icon) {
      this.selectedIcon = '$' + icon
      this.$emit('selectIcon', icon)
    }

  },

  created () {
    this.selectedIcon = this.active
  }
}

</script>

<style lang="sass" scoped>

@import '@/variables.sass'

.icon
  width: 36px
  height: 36px
  ::v-deep g
    fill: black

.active
  ::v-deep g
    fill: rgba(var(--primary))

</style>
